import { Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { appBarHeight } from "AttendanceForm/Constants/Styles";

export const AppBarStyles = makeStyles((theme: Theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.background.paper,
        height: appBarHeight,
    },
    title: {
        marginTop: 0,
        marginLeft: theme.spacing(2.5),
        marginRight: theme.spacing(2.5),
        color: theme.palette.primary.dark,
        fontSize: 36,
        lineHeight: 1.2,
        letterSpacing: "-0.00833em",
        fontWeight: "bold",
        [theme.breakpoints.down('sm')]: {
            fontSize: "30px",
        },
    },
}));